export default __webpack_public_path__ + "images/error.f70417eaefef75c7bb0cd05881f2ec90.svg";